import React from 'react';
import styles from './AppAvatar.module.css';

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

interface AppAvatarProps {
  avatar?: string;
  name: string;
  size?: AvatarSize;
}

const AppAvatar: React.FC<AppAvatarProps> = ({ avatar, name, size = 'md' }) => {
  return (
    <div className={`${styles.avatarContainer} ${styles[size]}`}>  
      {avatar ? (
        <img className={styles.avatarImage} src={avatar} alt={name} />
      ) : (
        <div className={styles.avatarFallback}>
          {name.charAt(0).toUpperCase()}
        </div>
      )}
    </div>
  );
};

export default AppAvatar;